import { render, staticRenderFns } from "./TourSubTitle.vue?vue&type=template&id=425156cd&scoped=true&"
import script from "./TourSubTitle.vue?vue&type=script&lang=js&"
export * from "./TourSubTitle.vue?vue&type=script&lang=js&"
import style0 from "./TourSubTitle.vue?vue&type=style&index=0&id=425156cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425156cd",
  null
  
)

export default component.exports